module.exports = __webpack_public_path__ + "img/feedback.c70b9caa.png";